<template>
  <Modal ref="baseModal">
    <div
      class="modal-popup active"
      tabindex="0"
      @keydown.enter.stop.prevent="confirm"
      @keydown.esc.stop.prevent="cancel"
    >
      <div class="modal-wrap">
        <div
          class="icon-box"
          :class="{
          'info-icon': iconClass == 'info',
          'info-icon-r' : iconClass == 'error',
          'check-icon' : iconClass == 'check',
          'back-icon' : iconClass == 'back'
        }"
        ></div>
        <p class="modal-title">{{title}}</p>
        <p class="modal-text" v-html="content"></p>
        <button type="button" class="cancel-btn" @click="cancel">{{cancelButtonText}}</button>
        <button
          ref="confirmButton"
          type="button"
          class="modal-btn"
          @click="confirm"
        >{{confirmButtonText}}</button>
      </div>
    </div>
  </Modal>
</template>
<script>
import Modal from "@/components/common/Modal.vue";
export default {
  components: {
    Modal,
  },
  data: () => ({
    title: "확인",
    content: "확인해 주세요.",
    confirmButtonText: "확인",
    cancelButtonText: "취소",
    resolvePromise: undefined,
    iconClass: "info",
  }),
  methods: {
    show(content) {
      this.setContent(content);

      return new Promise((resolve) => {
        this.resolvePromise = resolve;
        this.openModal();
      });
    },

    error(content) {
      this.iconClass = "error";
      return this.show(content);
    },

    info(content) {
      this.iconClass = "info";
      return this.show(content);
    },

    check(content) {
      this.iconClass = "check";
      return this.show(content);
    },

    back(content) {
      this.iconClass = "back";
      return this.show(content);
    },

    openModal() {
      this.$refs.baseModal.open();

      this.$nextTick(() => {
        this.$refs.confirmButton?.focus();
      });
    },

    confirm() {
      this.closeModal(true);
    },

    cancel() {
      this.closeModal(false);
    },

    closeModal(result) {
      this.$refs.baseModal.close();

      const resolve = this.resolvePromise;
      this.resolvePromise = undefined;
      resolve?.(result);
    },

    setContent(content) {
      if (content == undefined) {
        return;
      }

      this.title = content.title ? content.title : this.title;
      this.content = content.content ? content.content : this.content;
      this.confirmButtonText = content.confirmButtonText
        ? content.confirmButtonText
        : this.confirmButtonText;
      this.cancelButtonText = content.cancelButtonText
        ? content.cancelButtonText
        : this.cancelButtonText;
    },
  },
};
</script>